module.exports = __webpack_public_path__ + "static/media/arrow.7878fb44.svg";